export default __webpack_public_path__ + "static/media/pokemons.aed60b27.png";